import React, { Component } from 'react';
import ControlledSelect from 'components/lib/formElements/ControlledSelect';

export default class SeriesComparisonControlledSelect extends Component {
  constructor (props) {
    super(props);
    this.state = {
      errorText: null,
      menuHeight: 0,
      openMenu: this.props.openMenu,
    }
  }

  render() {
    return (
      <ControlledSelect
        ref="controlledSelect"
        clientId={this.props.clientId}
        error={this.props.error}
        items={this.props.productions}
        handleMenu={(v) => { this.setState({openMenu: v});}}
        isDialog={false}
        label={null}
        onChange={this.props.onChange}
        openMenu={this.state.openMenu}
        selectedItemName={this.props.selectedItemName}
        seriesComparison={true}
        selectedIds={this.props.selectedIds}
        style={{width:'30%', position: 'relative', padding: '20px 1vw'}} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/formElements/SeriesComparisonControlledSelect.js